var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('el-tabs',{attrs:{"tab-position":_vm.tabPosition}},[_c('el-tab-pane',{attrs:{"label":"基本设置"}},[_c('AccountCenterBasic')],1),_c('el-tab-pane',{attrs:{"label":"高级设置"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }